
// Import Hero section component
import Hero from "../components/Hero";
// Import image assets and CSS
import HeroImage from "../../assets/images/Homepage1.png";
import logo from "../../assets/images/Logo-light 1.png";
import service1 from "../../assets/images//Homepage 2.png";
import service2 from "../../assets/images/Homepage 3.png";
import service3 from "../../assets/images/Homepage 4.png";
import servicesBackground from "../../assets/images/BG_HomePage.jpg";
import "../../css/LandingPage.css";
// Import navigation and button components
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
// Import mortgage borrow calculator
import BorrowCalculator from "../calculators/MortgageBorrowCalculator";
import ButtonSecondary from "../components/ButtonSecondary";

/**
 * LandingPage component for displaying the homepage with hero, about, services, and calculator.
 *
 * Sections:
 * - Hero section: Title, subtitle, background image, and call-to-action button
 * - About Us: Company description
 * - Our Services: Cards for Mortgages, Personal Protection, and Equity Release
 * - Borrow Calculator: Mortgage borrow calculator component
 */
const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <div className="landing-page">
      {/* Hero section with title, subtitle, and logo */}
      <Hero
        //   title={"Tailored financial\nsolutions."}
        subtitle={"Independent Mortgage  and Protection Adviser"}
        backgroundImage={HeroImage}
        titleAlign="left"
        subtitleAlign="left"
        buttonText="BOOK A CONSULTATION"
        onButtonClick={() => {
          navigate("/contact");
        }}
        logo={logo}
      />
      {/* About Us section */}
      <div className="footer footer-legal ">
        <h2>About Us</h2>
        <div className="divider align-center"></div>
        <div className="content-large">
          Oakmont Financial Services is part of one of the largest Independent
          Mortgage and Financial Planning networks in the UK. We specialise in{" "}
          <strong>
            Mortgages, Personal Health Protection and Equity Release.
          </strong>
        </div>
      </div>
      {/* Our Services section with service cards */}
      <section
        className="services-section"
        style={{
          backgroundImage: `url(${servicesBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h2>Our Services</h2>
        <div className="divider align-center"></div>
        {/* Service cards row */}
        <div className="service-row">
          <div className="service-cards">
            {/* Mortgages card */}
            <div className="service-card">
              <img src={service1} alt="Commercial Financial advice" />
              <div className="subtitle-semibold">Mortgages</div>
              <div className="card-content">
                <div className="content-large">
                  Whether you are a first-time buyer, looking to remortgage, or
                  want to build on your buy to let portfolio. At Oakmont we can
                  help you.
                </div>
                <div className="content-small-italic">
                  Your home may be repossessed if you do not keep up repayments
                  on your mortgage.
                </div>
              </div>
              <Button
                text="Find Out More"
                variant="card"
                onClick={() => {
                  navigate("/services#mortgages");
                }}
              />
            </div>
            {/* Personal Protection card */}
            <div className="service-card">
              <img src={service3} alt="Personal Protection" />
              <div className="subtitle-semibold">Personal Protection</div>
              <div className="card-content">
                <div className="content-large">
                  There is no one size fits all solution when it comes to
                  protecting the things that matter, which is why we’re here to
                  help guide you to the right product.
                </div>
                {/* <div className="content-small-italic">
                  Your home may be repossessed if you do not keep up repayments
                  on your mortgage.
                </div> */}
              </div>
              <Button
                text="Find Out More"
                variant="card"
                onClick={() => {
                  navigate("/services#personal-protection");
                }}
              />
            </div>
            {/* Equity Release card */}
            <div className="service-card">
              <img src={service2} alt="Equity Release" />
              <div className="subtitle-semibold">Equity Release</div>
              <div className="card-content">
                <div className="content-large">
                  Equity Release can allow you to ‘unlock’ tax-free funds that
                  are tied up in your property, without moving or selling.
                </div>
                <div className="content-small-italic">
                  Equity release will reduce the value of your estate and can
                  affect your eligibility for means tested benefits.
                </div>
              </div>
              <Button
                text="Find Out More"
                variant="card"
                onClick={() => {
                  navigate("/services#equity-release");
                }}
              />
            </div>
          </div>
        </div>
      </section>
      {/* Borrow Calculator section */}
      <div className="footer footer-legal ">
        <BorrowCalculator />
      </div>
      <section
        className="services-section"
        style={{
          backgroundImage: `url(${servicesBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          padding: "40px 0",
        }}
      >
        <h2>Trustpilot Reviews</h2>
        <div className="divider align-center"></div>
        <ButtonSecondary
          text="View or Leave a Review"
          variant="card"
          onClick={() => {
            window.open(
              "https://uk.trustpilot.com/review/oakmontfinancialservices.co.uk",
              "_blank",
            );
          }}
        />
      </section>
    </div>
  );
};


// Export the LandingPage component as default
export default LandingPage;
